import { createSelector } from 'reselect';

const selectMembership = (state: any) => state.membership;

export const selectMembershipCurrentItem = createSelector([selectMembership], (membership) => membership.current);

export const selectMembershipListItems = createSelector([selectMembership], (membership) => membership.list);

export const selectMembershipItemById = (itemId: any) =>
    createSelector(selectMembershipListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectMembershipQueryItems = createSelector([selectMembership], (membership) => membership.query);

export const selectMembershipCreatedItem = createSelector([selectMembership], (membership) => membership.create);

export const selectMembershipPublishedItem = createSelector([selectMembership], (membership) => membership.publish);

export const selectMembershipUpdatedItem = createSelector([selectMembership], (membership) => membership.update);

export const selectMembershipReadItem = createSelector([selectMembership], (membership) => membership.read);

export const selectMembershipDeletedItem = createSelector([selectMembership], (membership) => membership.delete);

export const selectMembershipSearchedItems = createSelector([selectMembership], (membership) => membership.search);

export const selectMembershipItemsCount = createSelector([selectMembership], (membership) => membership.count);

export const selectMembershipItemsFilter = createSelector([selectMembership], (membership) => membership.filter);